/**
 * Popover direction
 */
export var PopoverDirection;
(function (PopoverDirection) {
    PopoverDirection["BOTTOM"] = "bottom";
    PopoverDirection["LEFT"] = "left";
    PopoverDirection["RIGHT"] = "right";
})(PopoverDirection || (PopoverDirection = {}));
/**
 * Popover arrow
 */
export var PopoverArrowPosition;
(function (PopoverArrowPosition) {
    PopoverArrowPosition["START"] = "start";
    PopoverArrowPosition["END"] = "end";
})(PopoverArrowPosition || (PopoverArrowPosition = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9wb3ZlckVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL3BvcG92ZXIvUG9wb3ZlckVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxnQkFJWDtBQUpELFdBQVksZ0JBQWdCO0lBQzFCLHFDQUFpQixDQUFBO0lBQ2pCLGlDQUFhLENBQUE7SUFDYixtQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFKVyxnQkFBZ0IsS0FBaEIsZ0JBQWdCLFFBSTNCO0FBT0Q7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxvQkFHWDtBQUhELFdBQVksb0JBQW9CO0lBQzlCLHVDQUFlLENBQUE7SUFDZixtQ0FBVyxDQUFBO0FBQ2IsQ0FBQyxFQUhXLG9CQUFvQixLQUFwQixvQkFBb0IsUUFHL0IifQ==